import { ActionIcon, Button, TextInput, Title } from "@mantine/core"
import { IconEye, IconEyeOff } from "@tabler/icons"
import { TFunction } from "i18next"
import { Dispatch, SetStateAction, useContext, useState } from "react"
import { useTranslation } from "react-i18next"
import logo from "../../assets/logo.png"
import background from "../../assets/unauthenticated-background.jpg"
import AuthenticationContext from "../AuthenticationContext"
import Props from "./Unauthenticated.types"

const LOGIN_BODY_PADDING = 32
const LOGO_HORIZONTAL_PADDING = 96

const verifyPassword = (
  password: string,
  setToken: (token: string) => void,
  setTextInputError: Dispatch<SetStateAction<string | null>>,
  setLoading: Dispatch<SetStateAction<boolean>>,
  t: TFunction<"translation">
) => {
  setLoading(true)

  fetch(
    process.env.REACT_APP_PRODUCTION_SERVER +
      "/admin/login?password=" +
      password,
    {
      method: "POST",
    }
  )
    .then((response) =>
      response.text().then((response) => {
        if (response === "Wrong password") {
          setTextInputError(t`Password non valida` as string)
        } else {
          setToken(response)
        }
      })
    )
    .catch(() => setTextInputError(t`Errore` as string))
    .finally(() => setLoading(false))
}

const Unauthenticated = ({ mobile }: Props) => {
  const [password, setPassword] = useState<string>("")
  const [textInputError, setTextInputError] = useState<string | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const [showPassword, setShowPassword] = useState<boolean>(false)
  const [, setToken] = useContext(AuthenticationContext)

  const { t } = useTranslation()

  const loginBody = (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        maxWidth: "384px",
        width: `calc(100% - ${LOGIN_BODY_PADDING * 2}px)`,
        margin: "auto",
        background: "white",
        padding: LOGIN_BODY_PADDING + "px",
        borderRadius: "4px",
        ...(mobile
          ? {
              height: `calc(100% - ${LOGIN_BODY_PADDING * 2}px)`,
              justifyContent: "space-between",
            }
          : {
              boxShadow:
                "rgb(0 0 0 / 20%) 0px 2px 4px -1px, rgb(0 0 0 / 14%) 0px 4px 5px 0px, rgb(0 0 0 / 12%) 0px 1px 10px 0px",
              justifyContent: "center",
            }),
      }}
    >
      <div style={{ width: "100%" }}>
        <img
          src={logo}
          alt="Resinglass"
          style={{
            width: `calc(100% - ${LOGO_HORIZONTAL_PADDING * 2}px)`,
            margin: `16px ${LOGO_HORIZONTAL_PADDING}px`,
          }}
        />
        <Title
          size="h1"
          style={{
            fontFamily: "Pirulen",
            textAlign: "center",
            marginTop: "8px",
          }}
        >
          Resinglass
        </Title>
        <TextInput
          value={password}
          onChange={(event) => {
            setPassword(event.target.value)
            setTextInputError(null)
          }}
          onKeyDown={({ code }) => {
            if (code === "Enter")
              verifyPassword(
                password,
                setToken,
                setTextInputError,
                setLoading,
                t
              )
          }}
          label={t`Password` as String}
          error={textInputError}
          size="md"
          style={{
            margin: "48px 0",
            paddingBottom: textInputError ? 0 : "21px",
          }}
          type={showPassword ? "text" : "password"}
          rightSection={
            <ActionIcon
              style={{ color: "black", marginRight: "8px" }}
              onClick={() => setShowPassword((showPassword) => !showPassword)}
            >
              {showPassword ? <IconEyeOff /> : <IconEye />}
            </ActionIcon>
          }
        />
      </div>
      <Button
        size="md"
        disabled={!password}
        onClick={() =>
          verifyPassword(password, setToken, setTextInputError, setLoading, t)
        }
        loading={loading}
      >
        {t`Accedi` as string}
      </Button>
    </div>
  )

  return mobile ? (
    loginBody
  ) : (
    <div
      style={{
        display: "flex",
        height: "100%",
        backgroundImage: `url(${background})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
    >
      {loginBody}
    </div>
  )
}

export default Unauthenticated
